import { render, staticRenderFns } from "./client-tags.vue?vue&type=template&id=184fd7a0&"
import script from "./client-tags.vue?vue&type=script&lang=js&"
export * from "./client-tags.vue?vue&type=script&lang=js&"
import style0 from "./client-tags.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('184fd7a0')) {
      api.createRecord('184fd7a0', component.options)
    } else {
      api.reload('184fd7a0', component.options)
    }
    module.hot.accept("./client-tags.vue?vue&type=template&id=184fd7a0&", function () {
      api.rerender('184fd7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/client-tags/client-tags.vue"
export default component.exports